import React, { useMemo } from "react";
import TableWrapper from "../Table/tableWrapper";
import {useSelector} from "react-redux";
import { calculatePaidDiscountAmount, createTableHeadersAndData } from "../../Util/TableHelpers/commonHelper";
import { DATE_FORMATS, formatDate, parseDate } from "../../Util/dateHelpers";
import { getEarningCSVDataLink } from "../../Util/TableHelpers/earningCSVDownloadHelper";

const columnConfigs = [
    {
        id: "servicePeriod",
        name: "Service Period",
        dataFunc: ({date}) => formatDate(date, DATE_FORMATS.MM_YYYY)
    },
    {
        id: "numberOfPaidAccounts",
        name: "Total Number of Paid Accounts",
        dataFunc: ({billingInfo}) => {
            const totalNumberOfAcc = billingInfo.billingInfos.length;
            const totalNumberOfActiveAcc = billingInfo.billedAccountsCount;
            const percentage = (totalNumberOfActiveAcc * 100 / totalNumberOfAcc).toFixed(2);
            return `${totalNumberOfActiveAcc} out of ${totalNumberOfAcc} (${percentage}%)`;
        }
    },
    {
        id: "totalUsageBilling",
        name: "Total Usage Billing($)",
        dataFunc: ({billingInfo}) => billingInfo.totalBillingAmount.toFixed(2)
    },
    {
        id: "totalBillCollected",
        name: "Total Bill Collected($)",
        dataFunc: ({billingInfo}) => calculatePaidDiscountAmount(billingInfo.billingInfos, 100)
    },
    {
        id: "yourEarning",
        name: "Your Earning($) (DISCOUNT%)",
        dataFunc: ({billingInfo, discount}) => calculatePaidDiscountAmount(billingInfo.billingInfos, discount)
    },
    {
        id: "details",
        name: "Details",
        dataFunc: ({billingInfo, date, accountsData, discount}) => {
            const fileName = "details_" + formatDate(date, DATE_FORMATS.YYYY_MM_DD);
            return getEarningCSVDataLink(fileName, billingInfo.billingInfos, accountsData, discount)
        }
    }
];

const tableOption = {
    firstChildHighlight: true
}

const EarningsTableSection = () => {
    const partnerDetails = useSelector(state => state.partnerDetails);
    const partnerAccountsObj = useSelector(state => state.partnerAccounts);
    const billingDataObj = useSelector(state => state.partnerBillingData);

    const tableInput = useMemo(() => {
        if (partnerDetails === null || partnerAccountsObj === null || billingDataObj === null) return [];

        const input = Object.entries(billingDataObj.billingFormattedObj).map(([key, value]) => {
            return {
                date: parseDate(key),
                billingInfo: value,
                discount: partnerDetails.billingDiscountAmount,
                accountsData: partnerAccountsObj.getAccountsObj(),
            }
        });

        input.sort((a, b) => a.date.getTime() - b.date.getTime()).reverse();

        return input.slice(0, 12);
    }, [partnerDetails, partnerAccountsObj, billingDataObj]);

    const processedColumnConfigs = columnConfigs.map(config => {
        if (config.id === "yourEarning") {
            config.name = config.name.replace("DISCOUNT", partnerDetails?.billingDiscountAmount ?? 0);
        }
        return config;
    });

    const {headers, data} = createTableHeadersAndData(tableInput, processedColumnConfigs);

    return (
        <div className="p-2 ps-0 min-width-md-parent">
            <span className="sub-title">Earnings</span>
            <TableWrapper tableHeaderArr={headers} tableBodyArr={data} option={tableOption} errorText="You do not have any earnings available to show"/>
        </div>
    )
}

export default EarningsTableSection;
